import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, message, Tag, Pagination, Alert, Button, Space, Popconfirm, Modal, Form, Input } from 'antd';
import CapacitacionService from '../../../../services/api/capacitaciones';
import helper from '../../../../utils/helper';
import { QuestionCircleOutlined } from '@ant-design/icons';
import CapacitacionFormularioModal from '../../../../components/Capacitaciones/CapacitacionFormularioModal';
import ConfiguracionService from '../../../../services/api/configuraciones';

const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

class IndexConfigurarCapacitacion extends Component {
  state = {
    cargando: false,
    open_modal_capacitacion: false,
    capacitaciones: [],
    open_bonificacion_modal: false,
    bono_colegiado_habil: 0,
    bono_colegiado_vitalicio: 0,
    configuracion_id: '',
    page: {
      number: 1,
      per_page: 15,
      order_column: 'created_at',
      order_type: 'desc',
      from: 0,
      to: 0,
      last_page: 0,
      total: 0,
      buscar_texto: '',
    },
  };

  
  setFormModal = (ref) => {
    this.formModalRef = ref;
  };

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(this.handleChangeLocation);

    if (this.props.location && this.props.location.search) {
      const queryString = new URLSearchParams(this.props.location.search);
      if (queryString) {
        const buscar_texto = queryString.get('buscar_texto');
        const configPage = Object.assign({}, this.state.page);
        configPage.buscar_texto = buscar_texto;
        this.setState({
          page: configPage,
        });
      }
    }

    this.cargarCapacitaciones();
    this.cargandoConfiguracions();
  }

  cargandoConfiguracions = () => {
    ConfiguracionService.getConfiguracions(
      '',
      (configuracion) => {
        if (configuracion) {
          this.setState({
            configuracion_id: configuracion.id,
            bono_colegiado_habil: parseFloat(configuracion.bono_colegiado_habil),
            bono_colegiado_vitalicio: parseFloat(configuracion.bono_colegiado_vitalicio)
          });
        }
      },
      (error) => {
        if (error) {
          message.error(error.message);
        }
      }
    );
  };

  handleChangeSearch = (value) => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = value.target.value;
    configPage.number = 0;
    this.setState({
      page: configPage,
      buscar_texto: value.target.value
    }, () => {
      this.cargarCapacitaciones();
    });
  }

  handleChangeSearchIcon = () => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = this.state.buscar_texto;
    this.setState({
      page: configPage,
      buscar_texto: this.state.buscar_texto
    }, () => {
      this.cargarCapacitaciones();
    });
  }

  cargarCapacitaciones = (path = undefined) => {
    this.setState({
      cargando: true,
    });

    if (!path || path === undefined) {
      path = `?page=${this.state.page.number}&per_page=${this.state.page.per_page}&order_column=${this.state.page.order_column}&order_type=${this.state.page.order_type}&pago_pendiente=true`;
      if (this.state.page && this.state.page.buscar_texto && this.state.page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.page.buscar_texto}`;
      }
    }

    CapacitacionService.getCapacitaciones(
      path,
      (page) => {
        if (page && page.data && page.data.length > 0) {
          const configPage = Object.assign({}, this.state.page);
          configPage.from = page.from;
          configPage.to = page.to;
          configPage.last_page = page.last_page;
          configPage.total = page.total;
          configPage.number = page.current_page;
          configPage.per_page = parseInt(page.per_page);
          configPage.buscar_texto = page.buscar_texto ? page.buscar_texto : '';

          this.setState({
            cargando: false,
            capacitaciones: page.data,
            page: configPage,
          });
        } else {
          this.setState({
            capacitaciones: [],
            cargando: false,
          });
        }
      },
      (error, result) => {
        if (error) {
          message.error(error.message);
          this.setState({
            cargando: false,
          });
        }
      }
    );
  };

  handleChangeLocation = (location, action) => {
    const queryString = new URLSearchParams(location.search);
    const buscar_texto = queryString.get('buscar_texto');

    if (buscar_texto && buscar_texto != null) {
      const page = Object.assign({}, this.state.page);

      page.buscar_texto = buscar_texto;

      this.setState({
        page,
      });

      setTimeout(() => {
        this.cargarCapacitaciones();
      }, 10);
    }
  };

  handleChangePerPage = (current, pageSize) => {
    const page = Object.assign({}, this.state.page);
    page.number = current;
    page.per_page = pageSize;
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&pago_pendiente=true`;
    if (page.buscar_texto !== undefined || page.buscar_texto !== '') {
      path = `${path}&buscar_texto=${page.buscar_texto}`;
    }
    this.props.history.push(path);
    this.cargarCapacitaciones(path);
  };

  showTotal = (total) => {
    return `Total ${total} registros`;
  };

  handleEditarCapacitacion = (capacitacion) => {
    this.setState({
      open_modal_capacitacion: true,
      capacitacion,
    });
  };

  handleCreateFormSubmit = (data) => {
    this.setState({ guardando: true });
    if (data.id) {
      CapacitacionService.updateCapacitacion(
        data,
        (response) => {
          if (response) {
            this.setState({
              guardando: false,
              open_modal_capacitacion: false,
              response,
            });
            this.cargarCapacitaciones();
            message.success('Datos actualizados exitosamente');
          }
        },
        (error) => {
          if (error) {
            if (this.formModalRef) {
              this.formModalRef.onFormUploadValidators(error);
            }
            message.error(error.message);
            this.setState({
              guardando: false,
              open_modal_capacitacion: true,
            });
          }
        }
      );
    } else {
      CapacitacionService.createCapacitacion(
        data,
        (response) => {
          if (response) {
            this.setState({
              guardando: false,
              open_modal_capacitacion: false,
              response,
            });
            this.cargarCapacitaciones();
            message.success('Datos guardados exitosamente');
          }
        },
        (error) => {
          if (error) {
            if (this.formModalRef) {
              this.formModalRef.onFormUploadValidators(error);
            }
            message.error(error.message);
            this.setState({
              guardando: false,
              open_modal_capacitacion: true,
            });
          }
        }
      );
    }
  };

  handleClickCloseCapacitacionModal = (e) => {
    this.setState({
      open_modal_capacitacion: false,
    });
  };

  handleClickOpenCapacitacionFormularioModal = () => {
    this.setState({
      rol: {},
      open_modal_capacitacion: true,
      buscar_texto: false,
      capacitacion: {}
    });
  };

  handleDelete = (rol_id) => {
    CapacitacionService.deleteCapacitacion(
      rol_id,
      (response) => {
        if (response) {
          this.setState({
            response,
          });
          this.cargarCapacitaciones();
          message.success('La rol seleccionada ha sido eliminada');
        }
      },
      (error) => {
        if (error) {
          message.error(error.message);
        }
      }
    );
  };

  showBonificacionModal = () => {
    this.setState({
      open_bonificacion_modal: true,
    });
  };

  handleBonificacionOk = e => {
    this.setState({
      open_bonificacion_modal: false,
    });

    this.updateConfiguracion();
  };
  
  updateConfiguracion = () => {
    this.setState({ guardando_configuracion: false });
    ConfiguracionService.updateConfiguracion(
      {
        id: this.state.configuracion_id,
        bono_colegiado_habil: this.state.bono_colegiado_habil,
        bono_colegiado_vitalicio: this.state.bono_colegiado_vitalicio
      },
      (response) => {
        if (response) {
          this.setState({
            guardando_configuracion: false,
            id: response.id,
            bono_colegiado_habil: this.state.bono_colegiado_habil,
            bono_colegiado_vitalicio: this.state.bono_colegiado_vitalicio,
          }, () => {
            this.cargandoConfiguracions();
          });
          message.success('Se actualizo con exíto.');
        }
      },
      (error) => {
        if (error) {
          message.error(error.message);
        }
        this.setState({ guardando_configuracion: false });
      }
    );
  };

  handleBonificacionCancel = e => {
    this.setState({
      open_bonificacion_modal: false,
    });
  };

  handleChangeBonoColegiadoHabil  = (e, fieldName) => {
    this.setState({
      bono_colegiado_habil: e.target.value,
    });
  };

  handleChangeBonoColegiadoVitalicio  = (e, fieldName) => {
    this.setState({
      bono_colegiado_vitalicio: e.target.value,
    });
  };

  render() {
    const columns = [
      {
        title: 'N°',
        dataIndex: 'name',
        key: 'name',
        responsive: ['lg'],
        width: 50,
        render: (text, record, index) => {
          return <div>{index + 1}</div>;
        },
      },
      {
        title: 'SKU Producto',
        dataIndex: 'producto_sku',
        key: 'producto_sku',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        width: 120,
      },
      {
        title: 'Nombre de capacitación',
        dataIndex: 'nombre',
        key: 'nombre',
        ellipsis: true,
        responsive: ['lg', 'xl'],
      },
      {
        title: 'Fecha Inicio',
        dataIndex: 'fecha_inicio',
        key: 'fecha_inicio',
        responsive: ['lg', 'xl'],
        ellipsis: true,
      },      
      {
        title: 'Fecha Fin',
        dataIndex: 'fecha_fin',
        key: 'fecha_fin',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        ellipsis: true,
      },
      {
        title: 'Gratuito',
        dataIndex: 'es_gratuito',
        key: 'es_gratuito',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        width: 220,
        render: (text) => (
          <Tag>
            {text ? 'SI': 'NO'}
          </Tag>
        ),
      },
      {
        title: 'Uso de Bono',
        dataIndex: 'es_uso_bonificacion',
        key: 'es_uso_bonificacion',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        width: 220,
        render: (text) => (
          <Tag>
            {text ? 'SI': 'NO'}
          </Tag>
        ),
      },
      {
        title: 'Acción',
        dataIndex: 'action',
        key: 'action',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
        render: (text, record) => (
          <Space size="middle">
            <a onClick={() => this.handleEditarCapacitacion(record)}>Editar</a>
            <Popconfirm
              title={`¿Estas seguro que deseas eliminar ${record.nombre ? record.nombre : ''}？`}
              cancelText="Cancelar"
              okText="Eliminar"
              okType="danger"
              onConfirm={() => {
                this.handleDelete(record.id);
              }}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            >
              <div className="link">Eliminar</div>
            </Popconfirm>
          </Space>
        ),
      },
    ];

    return (
      <div>
        <div className="page-header">
          <h2>Configuración Capacitaciones</h2>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
            <div className="topnav__search">
              <input
                type="text"
                placeholder="Buscar..."
                onChange={this.handleChangeSearch}
                value={ this.state.buscar_texto }
              />
              <i onClick={() => this.handleChangeSearchIcon()} className="bx bx-search" style={{cursor: 'pointer'}}></i>
            </div>
            <div>
              <Button type="primary" size="large" onClick={this.handleClickOpenCapacitacionFormularioModal}>
                Nuevo Capacitación
              </Button>
            </div>
            <div>
              <Button type="primary" size="large" onClick={this.showBonificacionModal}>
                <i className="bx bx-cog"></i> &nbsp;
                Bonificación
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {!helper.tienePermiso(this.props.permisos, 'Ver capacitaciones') ? (
                <Alert
                  message="Permiso"
                  description="No tiene permiso para ver lista de pagos pendientes"
                  type="error"
                />):
                <div className="card__body">
                  <Table
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={this.state.capacitaciones}
                    pagination={false}
                    loading={this.state.cargando}
                    size="small"
                  />
                  <div style={{ paddingTop: 12, textAlign: 'right' }}>
                    <Pagination
                      size="small"
                      showTotal={this.showTotal}
                      total={this.state.page.total}
                      current={this.state.page.number}
                      pageSize={this.state.page.per_page}
                      onChange={this.handleChangePerPage}
                      onShowSizeChange={this.handleChangePerPage}
                      pageSizeOptions={[10, 20, 30, 40]}
                      showQuickJumper
                      showSizeChanger
                    />
                  </div>
                </div>
              }              
            </div>
          </div>
        </div>
        {this.state.open_modal_capacitacion ? (
          <CapacitacionFormularioModal
            visible={this.state.open_modal_capacitacion}
            guardando={this.state.guardando}
            capacitacion={this.state.capacitacion}
            onFormSubmit={this.handleCreateFormSubmit}
            onCancel={this.handleClickCloseCapacitacionModal}
            ref={this.setFormModal}
          />
        ) : (
          ''
        )}

        <Modal
          title="Configuracion de Capacitación"
          visible={this.state.open_bonificacion_modal}
          onOk={this.handleBonificacionOk}
          okText="Actualizar"
          confirmLoading={this.state.guardando_configuracion}
          onCancel={this.handleBonificacionCancel}
        >
          <FormItem
              {...formItemLayout}
              label="Bono Colegiado Habíl"
              help={this.state.errors}
              required={false}
            >
              <Input
                onChange={(e) => this.handleChangeBonoColegiadoHabil(e, 'bono_colegiado_habil')}
                value={this.state.bono_colegiado_habil}
                autoComplete="off"
                id="bono_colegiado_habil"
                ref={(input) => {
                  this.nameInput = input;
                }}
              />
            </FormItem>
            <FormItem
              {...formItemLayout}
              label="Bono Colegiado Vitálicio"
              help={this.state.errors}
              required={false}
            >
              <Input
                onChange={(e) => this.handleChangeBonoColegiadoVitalicio(e, 'bono_colegiado_vitalicio')}
                value={this.state.bono_colegiado_vitalicio}
                autoComplete="off"
                id="bono_colegiado_vitalicio"
                ref={(input) => {
                  this.nameInput = input;
                }}
              />
            </FormItem>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisos: state && state.user && state.user.permisos.length > 0 ? state.user.permisos : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexConfigurarCapacitacion);
